import script from "./HomePageTopPart.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomePageTopPart.vue?vue&type=script&setup=true&lang=ts"

import "./HomePageTopPart.vue?vue&type=style&index=0&id=b4103f0a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4103f0a"]])

export default __exports__